import type { InventoryResource } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { AwsVolumesSection } from './awsVolumesSection';
import { GcpDisksSection } from './gcpDisksSection';

export const VolumesSection = ({
  resource,
  onEntityChange,
}: {
  resource: InventoryResource;
  onEntityChange: () => Promise<void>;
}) => {
  if (resource.cloudProvider === Provider.Aws) {
    return (
      <AwsVolumesSection resource={resource} onEntityChange={onEntityChange} />
    );
  }

  if (resource.cloudProvider === Provider.Gcp) {
    return <GcpDisksSection resource={resource} />;
  }

  return null;
};
